import { Component, OnInit } from '@angular/core';
import { PrinterEndpointsService, PrintService } from '../../common/index';
import { QueuePrinterComponent } from '../queue-printer.component';

@Component({
  selector: 'printer-vrt',
  templateUrl: './queue-printer-vrt.component.html',
  styleUrls: ['./queue-printer-vrt.component.scss'],
  providers: [PrinterEndpointsService, PrintService],
})
export class QueuePrinterVerticalComponent
  extends QueuePrinterComponent
  implements OnInit
{
  viewType = 'vertical';

  ngOnInit() {
    super.ngOnInit();
    super.loadPrinter();
  }

  refreshPage() {
    location.reload();
  }
}
